import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const VideoGuidelines: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Button onClick={() => navigate('/blog')} sx={{ mb: 3, textTransform: 'none' }}>
          {t('blog.backToBlog')}
        </Button>
        <Typography variant="overline" color="primary" sx={{ fontWeight: 600 }}>
          Policy · June 2026
        </Typography>
        <Typography variant="h3" component="h1" sx={{ my: 2, fontWeight: 700 }}>
          Video Guidelines — What You Can and Cannot Upload
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.85 }}>
          Everything you need to know about our content policies and what types of videos are allowed on IndeeClips.
        </Typography>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Allowed Content
        </Typography>
        <Box component="ul" sx={{ '& li': { mb: 1, color: 'text.secondary', lineHeight: 1.85 } }}>
          <li>Movies, web series, short films and documentaries</li>
          <li>Comedy sketches, stand-up and funny videos</li>
          <li>Music videos, covers and original songs</li>
          <li>Educational content, tutorials and how-to guides</li>
          <li>Gaming videos, walkthroughs and live streams</li>
          <li>News, current affairs and factual reporting</li>
          <li>Sports highlights, analysis and commentary</li>
          <li>Vlogs, lifestyle and personal content</li>
          <li>Technology reviews and unboxing videos</li>
          <li>Food, travel and lifestyle content</li>
        </Box>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Prohibited Content
        </Typography>
        <Box component="ul" sx={{ '& li': { mb: 1, color: 'text.secondary', lineHeight: 1.85 } }}>
          <li>Content that infringes copyright or intellectual property rights</li>
          <li>Sexually explicit or pornographic material</li>
          <li>Content promoting violence, self-harm or illegal activities</li>
          <li>Hate speech targeting individuals or groups</li>
          <li>Content involving exploitation of minors</li>
          <li>Misleading, fraudulent or deceptive content</li>
          <li>Spam or commercially deceptive material</li>
        </Box>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 4, lineHeight: 1.85 }}>
          Questions? Contact us at{' '}
          <Typography
            component="a"
            href="mailto:contact@indeeclips.com"
            sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            contact@indeeclips.com
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
};

export default VideoGuidelines;
